<template>
  <div class="flex justify-end mb-6" v-if="system.print_enabled">
    <button class="block py-2 px-3 rounded" :class="numberOfLocations ? 'text-white bg-accent hover:bg-accent' : 'text-gray-300 bg-white'" :disabled="!numberOfLocations" @click="openModal">
      Bulk Add/Remove {{ typePlural }} from campaign
    </button>

    <modal-small v-if="modalOpen" ref="modal" @close="modalOpen = false" size="small">
      <div v-if="saving" class="w-full flex justify-center my-6">
        <loader class="relative" />
      </div>

      <div v-else-if="complete" class="p-12 flex items-center gap-3 flex-col">
        <icon name="tick_2" class="w-16 h-16 text-accent" />
        <p>The campaign has been updated</p>
        <button class="block py-2 px-3 rounded text-gray-700 bg-gray-100 hover:bg-gray-200" @click="modalOpen = false">
          Close
        </button>
      </div>

      <div v-else class="p-6 flex flex-col gap-6">
        <div class="flex flex-col gap-2">
          <h4 class="font-bold text-lg">Bulk Campaign Update</h4>
          <p>From the selected regions, you are about to add or remove up to <strong>{{ numberOfLocations }}</strong> {{ typePlural }} in a campaign.</p>
        </div>

        <div class="flex flex-col gap-2">
          <label class="flex gap-2">
            <input type="radio" name="bulk_type" v-model="form.action" value="add" />
            <span>Add all of these {{ typePlural }} to a campaign</span>
          </label>

          <label class="flex gap-2">
            <input type="radio" name="bulk_type" v-model="form.action" value="remove" />
            <span>Remove all of these {{ typePlural }} from a campaign</span>
          </label>
        </div>

        <div v-if="campaigns === null" class="w-full flex justify-center">
          <loader class="relative" />
        </div>
        <div v-else class="flex flex-col gap-2">
          <label>Campaign</label>
          <select-wrapper>
            <select v-model="form.campaign_id">
              <option :value="null">[Please Select]</option>
              <option v-for="campaign in campaigns" :key="campaign.id" :value="campaign.id">
                {{ campaign.name }}
              </option>
            </select>
          </select-wrapper>
        </div>

        <div class="flex flex-wrap justify-end gap-3">
          <button class="block py-2 px-3 rounded text-gray-700 bg-gray-100" @click="modalOpen = false">
            Cancel
          </button>

          <button class="block py-2 px-3 rounded" :class="form.campaign_id ? 'text-white bg-accent hover:bg-accent' : 'text-gray-300 bg-gray-100 hover:bg-gray-200'" :disabled="!form.campaign_id" @click="submit">
            Update Campaign
          </button>
        </div>
      </div>
    </modal-small>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ModalSmall from './ModalSmall'
import RegionService from '@/services/RegionService'

export default {
  components: {
    ModalSmall
  },
  props: {
    type: {
      default: 'street'
    },
    numberOfLocations: {
      default: 0
    }
  },
  data() {
    return {
      modalOpen: false,
      form: {
        action: 'add',
        campaign_id: null
      },
      campaigns: null,
      saving: false,
      complete: false
    }
  },
  computed: {
    ...mapState(['system', 'selectedRegions']),
    typePlural() {
      return this.type === 'street' ? 'streets' : 'localities'
    }
  },
  methods: {
    openModal() {
      this.saving = false
      this.complete = false
      this.form.campaign_id = null
      this.form.action = 'add'
      this.modalOpen = true
      this.getCampaigns()
    },
    getCampaigns () {
      if(this.campaigns) {
        return
      }

      RegionService.getCampaigns()
        .then(({ data }) => {
          this.campaigns = data.data
        })
    },
    submit() {
      this.saving = true

      RegionService.bulkAddRemoveCampaignLocations(this.form.action, this.form.campaign_id, this.type, this.selectedRegions)
        .then(() => {
          this.saving = false
          this.complete = true
          this.$emit('saved')
        }, () => {
          this.saving = false
        })
    }
  }
};
</script>
